'use client'

import clsx from 'clsx'

export default function PasswordModal ({
  error,
  label,
  heading,
  btnLabel
}) {
  const handleSubmit = (e) => {
    // change the password and base64 encode it
    // send the password to the server
    let password = e.target.token.value
    password = Buffer.from(password).toString('base64')
    e.target.token.value = password
  }

  return (
    <div className={clsx(
      'flex items-center justify-center min-h-screen w-full'
    )}
    >
      {/* // heading */}
      <div
        className={clsx(
          'w-full max-w-sm p-8 shadow-lg rounded-xl',
          'bg-white',
          'border-1 border-gray-100',
          'ring-1 ring-gray-200 ring-opacity-45 w-[200px] md:w-[300px] lg:w-[400px]'
        )}
      >
        <div className='header mb-6'>
          <h2 className={clsx(
            'md:text-lg text-sm font-bold text-center',
            'text-gray-900'
          )}
          >
            {heading}
          </h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className='mb-4'>
            <label
              htmlFor='password'
              className={clsx(
                'block mb-3 text-xs md:text-sm text-start',
                'text-gray-800'
              )}
            >
              {label}
            </label>
            <input
              type='password'
              id='token'
              name='token'
              placeholder='***************'
              className={clsx(
                'w-full px-3 py-2 leading-tight rounded shadow appearance-none ring-1',
                'focus:outline-none focus:shadow-outline',
                'text-gray-700',
                error ? 'ring-red-500' : ' ring-gray-200 '
              )}
              autoFocus
              required
              onKeyDown={(e) => {
                // change the class name of the input field if error bg-red-100 remove on key down
                e.target.className = clsx(
                  // remove border-red-500 bg-red-100 from classes
                  e.target.className.replace(/ring-red-500/g, '')
                )
              }}
            />
          </div>
          <div>
            <button
              type='submit'
              className={clsx(
                'w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md',
                'text-white bg-indigo-600',
                'hover:bg-indigo-700',
                'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
              )}
            >
              {btnLabel}
            </button>
          </div>
          {error ? <div><p className={clsx('pt-2 text-xs text-center text-red-500')}>Password is Incorrect</p></div> : <></>}
        </form>
      </div>
    </div>
  )
}
